// @generated
// This file was automatically generated and should not be edited.
// Run `dev generate pipeline-frontend` to regenerate.

/* eslint-disable unused-imports/no-unused-imports */

// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {ColumnTypeValidationFlag} from 'data-frames/util/validateColumnType';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {PipelineStepDataKind, PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStepShape} from 'pipelines/StepShapeUtils';

export const RUN_HIGHRES_PROTOCOL_STEP_SHAPES = [
  {
    stepType: PipelineStepType.RUN_HIGHRES_PROTOCOL,
    isDeprecated: false,
    version: 0,
    inputDataShapes: {
      'Input dataset': {
        systemName: 'Input dataset',
        displayName: 'Input dataset',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      }
    },
    outputDataShapes: {
      'Output files': {
        systemName: 'Output files',
        displayName: 'Output files',
        kind: PipelineStepDataKind.FILE,
        isMulti: true,
        isRequired: false
      },
      'Log files': {
        systemName: 'Log files',
        displayName: 'Log files',
        kind: PipelineStepDataKind.FILE,
        isMulti: true,
        isRequired: false
      },
      'Data Archive': {
        systemName: 'Data Archive',
        displayName: 'Data Archive',
        kind: PipelineStepDataKind.FILE,
        isMulti: false,
        isRequired: false
      }
    },
    config: {
      scientificProtocolId: {
        kind: 'string',
        required: true
      },
      name: {
        kind: 'string',
        required: true
      },
      requestedByUserId: {
        kind: 'string',
        required: true
      },
      cellarioSystemId: {
        kind: 'string',
        required: true
      },
      ports: {
        kind: 'array',
        required: true,
        elementSpec: {
          kind: 'shape',
          required: true,
          fields: {
            portId: {
              kind: 'string',
              required: true
            },
            labwareTypeId: {
              kind: 'string',
              required: true
            },
            plateIdColumn: {
              kind: 'columnReference',
              required: true,
              inputDataName: 'Input dataset',
              validationOptions: null
            }
          }
        }
      },
      parameters: {
        kind: 'anything',
        required: false
      }
    }
  }
] as const satisfies ReadonlyArray<PipelineStepShape>;
